import { Vec3 } from 'playcanvas';

/** Avatar 动画语义映射，允许用户把任意 GLB 动画绑定到漫游状态。 */
type AvatarAnimationMapping = {
    idle: string;
    run: string;
    sprint: string;
    jumpIdle: string;
    jumpRun: string;
    fall: string;
    rotateLeft: string;
    rotateRight: string;
};

/** WalkController 暴露给 Avatar 的只读移动状态快照。 */
type WalkAvatarState = {
    eyePosition: Vec3;
    footPosition: Vec3;
    velocity: Vec3;
    grounded: boolean;
    jumping: boolean;
    jumpStarted: boolean;
    jumpHadInput: boolean;
    yaw: number;
    moveMagnitude: number;
};

const DEFAULT_AVATAR_MAPPING: AvatarAnimationMapping = {
    idle: 'idle',
    run: 'run',
    sprint: 'sprint',
    jumpIdle: 'jump_idle',
    jumpRun: 'jump_running',
    fall: 'falling',
    rotateLeft: 'rotate_left',
    rotateRight: 'rotate_right'
};

/**
 * 创建可复用的 Avatar 状态对象，避免每帧分配临时向量。
 *
 * @returns 初始化后的 Avatar 状态对象。
 */
const createWalkAvatarState = (): WalkAvatarState => ({
    eyePosition: new Vec3(),
    footPosition: new Vec3(),
    velocity: new Vec3(),
    grounded: false,
    jumping: false,
    jumpStarted: false,
    jumpHadInput: false,
    yaw: 0,
    moveMagnitude: 0
});

export type { AvatarAnimationMapping, WalkAvatarState };
export { DEFAULT_AVATAR_MAPPING, createWalkAvatarState };
